module.exports = __webpack_public_path__ + "media/images/hackerrank/mobile-a171f675946f5fcb9cf5a175d8118e40.png";